import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Unstake {stakeToken} (Deprecated)',
    description:
      'Current balance {amount} {token} (deprecated version).<br />To continue earning rewards and ensure compatibility, please:',
    note: 'This will upgrade your tokens to the latest supported version.',
  },
};
